import { render, staticRenderFns } from "./InmportacionPedidos.vue?vue&type=template&id=054a6394&scoped=true&lang=pug"
import script from "./InmportacionPedidos.vue?vue&type=script&lang=js"
export * from "./InmportacionPedidos.vue?vue&type=script&lang=js"
import style0 from "./InmportacionPedidos.vue?vue&type=style&index=0&id=054a6394&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "054a6394",
  null
  
)

export default component.exports